import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  OutlinedInput,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { Switch } from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";

import { RPM_DEVICE_OPTIONS } from "static/constants";
import useCheckSaasAccountUser from "hooks/useCheckSaasAccountUser";
import "components/pages/transmissions/modal/patient/tabs/deviceInformation/RPMDevice.css";
import { FieldArray } from "formik";

const RPMDeviceInput = ({
  rpmDevices,
  allowInitialRPMModal,
  errors,
  touched,
  setFieldValue,
}) => {
  const isSaasAccountUser = useCheckSaasAccountUser();

  return !isSaasAccountUser ? (
    <FieldArray
      name="rpm_devices"
      render={({ push, remove }) => (
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} style={{ textAlign: "left" }}>
            <div className="patient-form__info--header">RPM Device</div>
          </Grid>

          {rpmDevices?.map((data, index) => {
            const { imei, active, rpmDeviceName } = data;
            return (
              <Grid
                container
                item
                columnSpacing={2}
                alignItems="center"
                key={index}
              >
                <Grid item xs={5}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    margin="none"
                    error={
                      touched?.rpm_devices?.[index]?.rpmDeviceName &&
                      !!errors?.rpm_devices?.[index]?.rpmDeviceName
                    }
                  >
                    <InputLabel required>RPM Device Type</InputLabel>
                    <Select
                      labelId="rpm-device-name-label"
                      style={{ textAlign: "left" }}
                      id="rpmDeviceName"
                      value={rpmDeviceName || ""}
                      name="rpmDeviceName"
                      variant="outlined"
                      onChange={(event) => {
                        const value = event.target.value;
                        // handleChange(index, value, "rpmDeviceName");
                        setFieldValue(
                          `rpm_devices[${index}].rpmDeviceName`,
                          value
                        );
                      }}
                      input={
                        <OutlinedInput
                          fullWidth
                          label="RPM Device Type"
                          required
                        />
                      }
                    >
                      {RPM_DEVICE_OPTIONS.map((rpmDevice, idx) => {
                        const isSelected = rpmDevices?.some(
                          (rpm) => rpm.rpmDeviceName === rpmDevice.key
                        );
                        return (
                          <MenuItem
                            value={rpmDevice.key}
                            key={idx}
                            disabled={isSelected}
                          >
                            {rpmDevice.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  {touched?.rpm_devices?.[index]?.rpmDeviceName &&
                    Boolean(errors?.rpm_devices?.[index]?.rpmDeviceName) && (
                      <FormHelperText error>
                        {errors?.rpm_devices?.[index]?.rpmDeviceName}
                      </FormHelperText>
                    )}
                </Grid>

                <Grid item xs={5}>
                  <TextField
                    required
                    fullWidth
                    margin="none"
                    variant="outlined"
                    name="imei"
                    label="IMEI"
                    value={imei}
                    onInput={(event) => {
                      const input = event.target;
                      if (input.value.length > 50) {
                        input.value = input.value.slice(0, 50); // Truncate extra characters
                      }
                    }}
                    onChange={(event) => {
                      const value = event.target.value;

                      if (/^\d*$/.test(value)) {
                        setFieldValue(`rpm_devices[${index}].imei`, value);
                      }
                    }}
                    error={
                      touched?.rpm_devices?.[index]?.imei &&
                      !!errors?.rpm_devices?.[index]?.imei
                    }
                    helperText={
                      touched?.rpm_devices?.[index]?.imei &&
                      errors?.rpm_devices?.[index]?.imei
                    }
                  />
                </Grid>

                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  xs={2}
                  margin="none"
                >
                  <Grid item>
                    <FormControlLabel
                      label="Active"
                      labelPlacement="start"
                      control={
                        <Switch
                          name="deviceActive"
                          checked={active}
                          onChange={() => {
                            // handleChange(index, !active, "active");
                            setFieldValue(
                              `rpm_devices[${index}].active`,
                              !active
                            );
                          }}
                        />
                      }
                    />
                  </Grid>
                  {((allowInitialRPMModal && rpmDevices?.length > 1) ||
                    (allowInitialRPMModal === false &&
                      rpmDevices?.length >= 1)) && (
                    <Grid item>
                      <DeleteIcon
                        className="mr-2 rpm-device-information__delete"
                        onClick={() => {
                          // handleRemove(index);
                          remove(index);
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            );
          })}
          {rpmDevices?.length < RPM_DEVICE_OPTIONS.length && (
            <Grid item>
              <span
                className="rpm-device-information__add-rpm-device"
                onClick={() => {
                  push({
                    rpmDeviceName: "",
                    imei: "",
                    active: false,
                  });
                }}
              >
                <AddIcon className="rpm-device-information__add-icon" />
                <span className="rpm-device-information__add-text">
                  Add RPM Device
                </span>
              </span>
            </Grid>
          )}
        </Grid>
      )}
    />
  ) : null;
};

export default RPMDeviceInput;
